import { cn } from "@ui/utils"

export default function InputLabel({
  label,
  description,
  className,
}: {
  label: React.ReactNode
  description: string
  className?: string
}) {
  return (
    <div className="min-w-20 truncate py-1 text-right">
      <div className={cn("h-5 truncate text-sm leading-snug font-medium", className)}>{label}</div>
      <div className="text-muted-foreground text-xs">{description}</div>
    </div>
  )
}
